import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';

export default function Toaster({ trigger, status, symbol, message }) {
  const [open, setOpen] = useState(trigger);

  useEffect(() => {
    setOpen(trigger);
  }, [trigger]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      onClose={handleClose}
      message={
        <>
          <Typography gutterBottom variant="" component="div" sx={{ paddingTop:1, fontSize: 24, fontWeight: 'bold', display: 'inline-block', verticalAlign: 'middle', marginX:1 }}>
            {symbol}
          </Typography>
            {message}
        </>
      }
      ContentProps={{
        sx: status
          ? {
              backgroundColor: '#E9EFEC',
              color: '#3E7B27',
            }
          : {
              backgroundColor: '#F8EDED',
              color: '#C7253E',
            },
      }}
    />
  );
}
Toaster.propTypes = {
  trigger: PropTypes.bool,
  status: PropTypes.bool,
  symbol: PropTypes.string,
  message: PropTypes.string,
};
